import { AnyAction } from 'redux';
import { GesamtpreisMitRabattChanged, GlobalActions } from '@ps20-frontend/shop-integration-redux';

export const gesamtbeitragMitRabattReducer = function (
  sectionState = 0,
  action: AnyAction,
): number {
  if (action.type === GlobalActions.GESAMTPREIS_MIT_RABATT_CHANGED) {
    const actionPayload: GesamtpreisMitRabattChanged = action.payload;
    return actionPayload.gesamtpreisMitRabatt;
  }
  return sectionState;
};
